import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  FileText,
  Search,
  DollarSign,
  Building2,
  CreditCard,
  Users,
  Package,
  TrendingUp,
  TrendingDown,
  Briefcase,
  Home,
  TicketCheck,
  Landmark,
  HandCoins,
} from "lucide-react";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import { FaSave, FaEye, FaPlus } from "react-icons/fa";
import { TbLayoutSidebarRightExpand } from "react-icons/tb";
import { TbLayoutSidebarLeftExpand } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaUserTie,
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaUniversity,
  FaMoneyBillWave,
  FaRegCreditCard,
  FaFileSignature,
  FaCommentDots,
  FaTasks,
} from "react-icons/fa";
import { MdWork, MdOutlineDescription } from "react-icons/md";
import { AiOutlineNumber } from "react-icons/ai";
import { BsCurrencyExchange } from "react-icons/bs";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

import CreditCustomerList from "../components/common/CreditCustomerList";
import Modal from "../components/common/CommonModal";

const Reciept = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isFilterByDate, setIsFilterByDate] = useState(false);
  const [isOnAc, setIsOnAc] = useState(false);
  const [differenceModalOpen, setDifferenceModalOpen] = useState(false);
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [debitModalOpen, setDebitModalOpen] = useState(false);
  const [isExtendTable, setIsExtendTable] = useState(false);
  // const [filteredAccounts, setFilteredAccounts] = useState(accounts);
  const [filteredAccounts, setFilteredAccounts] = useState(null);
  const [filteredCreditAccounts, setFilteredCreditAccounts] = useState(null);
  // const [filteredSearchedAccounts, setFilteredSearchedAccounts] =
  //   useState(null);
  const [selectedCreditAccount, setSelectedCreditAccount] = useState(null);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [selectedDifferenceAccount, setselectedDifferenceAccount] =
    useState(null);
  // const [inputCreditValue, setInputCreditValue] = useState("-");
  const [inputCreditValue, setInputCreditValue] = useState("-");
  const [inputCreditValueAccount, setInputCreditValueAccount] = useState("");
  const [inputCreditValueDescription, setInputCreditValueDescription] =
    useState("");
  const [descriptionInput, setDescriptionInput] = useState("");
  const [commentsInput, setCommentsInput] = useState("");
  const [jobCodeInput, setJobCodeInput] = useState("");
  const [cCenterInput, setcCenterInput] = useState("");
  const [inputDebitValue, setInputDebitValue] = useState("-");
  const [inputDebitValueAccount, setInputDebitValueAccount] = useState("");
  const [inputDebitValueDescription, setInputDebitValueDescription] =
    useState("-");

  const [inputDifferenceValue, setinputDifferenceValue] = useState("");
  const [inputDifferenceValueAccount, setinputDifferenceValueAccount] =
    useState("");
  const [inputDifferenceValueDescription, setinputDifferenceValueDescription] =
    useState("");
  const [searchDebitAccountTerm, setSearchDebitAccountTerm] = useState(null);
  const [searchCreditAccountTerm, setSearchCreditAccountTerm] = useState(null);
  const [searchDifferenceAccountTerm, setSearchDifferenceAccountTerm] =
    useState(null);
  const [accounts, setAccounts] = useState(null);
  const [outstandingRV, setOutstandingRV] = useState(null);
  const [outstandingSearchTerm, setOutstandingSearchTerm] = useState("");
  const [creditAccounts, setCreditAccounts] = useState(null);
  const [initialDrList, setInitialDrList] = useState(null);
  const [rvnoFromAPI, setRVnoFromAPI] = useState(null);
  const [value, setValue] = useState("ALL");
  const [valueToCredit, setValueToCredit] = useState("CUSTOMERS");
  const [valueToDifference, setValueToDifference] = useState("EXPENSES");
  const [rvType, setRvType] = useState("RV-C");
  const [rvApiUrl, setRVApiUrl] = useState("");
  const [selectedDr, setSelectedDr] = useState("");
  const [selectedDrDesc, setSelectedDrDesc] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const [debitDropdownOpen, setDebitDropdownOpen] = useState(false);
  const [creditDropdownOpen, setCreditDropdownOpen] = useState(false);
  const [differenceDropdownOpen, setDifferenceDropdownOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");

  const [transferAccountBlock, setTransferAccountBlock] = useState(false);
  const [transferAccountPopup, setTransferAccountPopup] = useState(false);
  const [amounts, setAmounts] = useState([]);
  const [sumOfAmounts, setSumOfAmounts] = useState(null);
  const searchInputRef = useRef(null);
  const crInputRef = useRef(null);
  const crInputWrapperRef = useRef(null);
  const [crInputWrapperFocus, setCrInputWrapperFocus] = useState(false);
  // const [crWrapperFocus, setCrWrapperFocus] = useState(false);
  const onAmtRecievedRef = useRef(null);

  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [amtRecieved, setAmtRecieved] = useState("");
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [vNO, setVNO] = useState(null);
  const [creditCardNo, setCreditCardNo] = useState(null);
  const [receiptSavedPopup, setReceiptSavedPopup] = useState(false);
  const [jvDate, setJvDate] = useState(today);
  // const [chequeDate, setChequeDate] = useState(
  //   new Date().toISOString().split("T")[0]
  // );
  const [chequeDate, setChequeDate] = useState(null);
  const [chequeNO, setChequeNO] = useState(null);
  const [chequeBank, setChequeBank] = useState(null);
  const [salesmanList, setSalesmanList] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState(null);
  const [differenceAmount, setDifferenceAmount] = useState(null);
  const currentDate = dayjs().format("YYYY-MM-DD");
  const [fcType, setFcType] = useState("AED");

  const [isEditMode, setIsEditMode] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const editReceiptData = location?.state?.rvEditData;
    if (!editReceiptData) return;
    console.log("editReceiptData:", editReceiptData);
    setIsEditMode(true);
    setInputCreditValue(
      `${editReceiptData.ACCOUNT} | ${editReceiptData.CUSTOMER}`,
    );
    setSelectedCreditAccount(editReceiptData);
    setInputCreditValueAccount(editReceiptData.ACCOUNT);
    setInputCreditValueDescription(editReceiptData.CUSTOMER);
  }, [location?.state?.rvEditData]);

  const resetForm = () => {
    setSelectedRows([]);
    setIsFilterByDate(false);
    setIsOnAc(false);
    setDebitModalOpen(false);
    setDifferenceModalOpen(false);
    setCreditModalOpen(false);
    setIsExtendTable(false);

    setSelectedDebitAccount(null);
    setselectedDifferenceAccount(null);
    setSelectedCreditAccount(null);

    setInputCreditValue("-");
    setInputCreditValueAccount("");
    setInputCreditValueDescription("");

    // setselectedCr("");
    // setselectedCrDesc("");
    // setinputDebitValue("-");
    // setinputDebitValueAccount("");
    // setinputDebitValueDescription("");
    setinputDifferenceValue("");
    setinputDifferenceValueAccount("");
    setinputDifferenceValueDescription("");

    setSearchCreditAccountTerm(null);
    setSearchDebitAccountTerm(null);
    setSearchDifferenceAccountTerm(null);
    setOutstandingRV(null);
    setValue("ALL");
    setValueToCredit("CUSTOMERS");
    setValueToDifference("EXPENSES");
    // setRvType("RV-C");
    setCreditDropdownOpen(false);
    setDebitDropdownOpen(false);
    setDifferenceDropdownOpen(false);
    setAmounts([]);
    setSumOfAmounts(null);
    setCrInputWrapperFocus(true);
    // setFromDate(today);
    // setToDate(today);
    // setFromDate(null);
    // setToDate(null);
    setSelectedToggle([]);
    setFcType(currencies[0] || null);
    setChequeNO(null);
    setChequeDate(null);
    setChequeBank(null);
    setAmtRecieved("");
    // amtRecieved
    setIsTableVisible(false);
    setSelectedCurrency(currencies[0] || null); // Reset to default currency
    setJvDate(today);
    setDescriptionInput("");
    setVNO(null);
    setCommentsInput("");
    setJobCodeInput("");
    setcCenterInput("");
    setSelectedSalesman(null);
    setCreditCardNo(null);
    setChequeNO(null);
    setChequeDate(null);
    setChequeBank(null);
    setTransferAccountBlock(false);
    setTransferAccountPopup(false);
    setDifferenceAmount(null);

    // Re-fetch PV number to get the next voucher number
    fetchRVList();

    // Set focus back to Debit input
    setTimeout(() => {
      if (crInputRef.current) {
        crInputRef.current.focus();
      }
    }, 0);
  };

  const handleClear = () => {
    setFromDate(today);
    setToDate(today);
  };

  useEffect(() => {
    if (isOnAc && onAmtRecievedRef.current) {
      onAmtRecievedRef.current.focus();
    }
  }, [isOnAc]);

  useEffect(() => {
    if (debitModalOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [debitModalOpen]);

  // Ensure selectedCurrency is initialized once currencies are loaded
  useEffect(() => {
    if (currencies.length > 0 && !selectedCurrency) {
      const defaultCurrency =
        currencies.find((item) => item.rate === 1) || currencies[0];
      setSelectedCurrency(defaultCurrency);
    }
  }, [currencies, selectedCurrency]);

  useEffect(() => {
    const rate = (selectedCurrency || currencies[0])?.rate ?? 1;
    setDifferenceAmount((amtRecieved * rate) - sumOfAmounts);
  }, [amtRecieved, sumOfAmounts, selectedCurrency, currencies]);

  useEffect(() => {
    if (valueToDifference) {
      fetchAccountList(valueToDifference);
    }
  }, [valueToDifference]);

  useEffect(() => {
    // fetchOutstandingRV();
    fetchCurrencyList();
    fetchAccountList();
    fetchAccountCreditList();
    fetchRVList();
    fetchInitialDrList();
    crInputRef.current.focus();
    setCrInputWrapperFocus(true);
    fetchSalesmanList();
    fetchSalesmanFromLocal();
    //     setTimeout(() => {
    //   if (crInputRef.current) {
    //     crInputRef.current.focus();
    //   }
    //   setCrWrapperFocus(true);
    // }, 0);
  }, []);

  const fetchSalesmanFromLocal = () => {
    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const salesman_from_local_storage =
      currentUser_from_local_storage?.sales_man;
    setSelectedSalesman(salesman_from_local_storage);
  };

  useEffect(() => {
    console.log("inputCreditValue", inputCreditValue);
    console.log("inputCreditValue?.length ", inputCreditValue?.length);
    if (inputCreditValue?.length > 1) {
      setIsTableVisible(true);
      fetchOutstandingRV();
      setCrInputWrapperFocus(false);
    } else {
      setIsTableVisible(false);
      crInputRef.current.focus();
      setCrInputWrapperFocus(true);
    }
  }, [inputCreditValue]);

  // useEffect(() => {
  //   if (isTableVisible) {
  //     fetchOutstandingRV();
  //   }
  // }, [isTableVisible]);

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";

  let currentSelectedDepartment = localStorage.getItem(
    "currentSelectedDepartment",
  )
    ? localStorage.getItem("currentSelectedDepartment")
    : "-";

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  useEffect(() => {
    setFilteredAccounts(accounts);
  }, [accounts]);

  // useEffect(() => {
  //   setFilteredCreditAccounts(creditAccounts);
  // }, [creditAccounts]);

  useEffect(() => {
    if (!inputCreditValue?.trim()) {
      setFilteredCreditAccounts(creditAccounts);
    } else {
      const term = inputCreditValue?.toLowerCase();
      const filtered = creditAccounts?.filter(
        (acc) =>
          acc.ACCOUNT?.toLowerCase()?.includes(term) ||
          acc.DESCRIPTION?.toLowerCase()?.includes(term),
      );
      setFilteredCreditAccounts(filtered);
    }
  }, [inputCreditValue, creditAccounts]);

  const [selected, setSelected] = useState("cash");

  const handleChange = (e) => {
    setValue(e.target.value);
    setSelected(e.target.value);
    handleChangePayment(e);
    handleChangeRVType(e);
  };

  useEffect(() => {
    let valueToAPI = "";

    if (paymentMethod === "cash") {
      valueToAPI = "cash";
    } else if (paymentMethod === "cheque") {
      valueToAPI = "pdc";
    } else if (paymentMethod === "bank") {
      valueToAPI = "bank";
    } else if (paymentMethod === "creditcard") {
      valueToAPI = "bank";
    }

    if (valueToAPI) {
      // setInputDebitValue(`${selectedDr || ""} | ${selectedDrDesc || ""}`)
      fetchAccountList(valueToAPI);
      const allowedType = typeMapping[paymentMethod?.toLowerCase()] || null;
      if (allowedType) {
        setValue(allowedType.toUpperCase());
      }
    }
  }, [paymentMethod]);

  useEffect(() => {
    console.log("valueToCredit:", valueToCredit);

    if (valueToCredit) {
      // setInputDebitValue(`${selectedDr || ""} | ${selectedDrDesc || ""}`)
      fetchAccountList(valueToCredit);
      // const allowedType = typeMapping[paymentMethod?.toLowerCase()] || null;
      // if (allowedType) {
      //   setValue(allowedType.toUpperCase());
      // }
    }
  }, [valueToCredit]);

  const fetchSalesmanList = async () => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";
    // const url = ${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO};
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentSelectedDepartment}`;
    try {
      const response = await axios.get(url);
      console.log("salesmanList Response data:", response.data);
      setSalesmanList(response.data || []);
    } catch (err) {
      console.error("Error while loading salesman List data:", err);
      setSalesmanList([]);
    }
  };

  const fetchOutstandingRV = async () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMOutstandingRVPV/${COMPANY_CODE}/RECEIPTS/${fromDate}/${toDate}/${selectedCreditAccount?.ACCOUNT}/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("fetchOutstandingRV List :", data);
      setOutstandingRV(data);
      // DESCR
    } catch (err) {
      console.error("Error while fetchOutstandingRV", err);
    }
  };

  const fetchAccountList = async (valueToAPI) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${currentSelectedDepartment}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      setAccounts(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  const fetchAccountCreditList = async (valueToAPI) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${currentSelectedDepartment}/${valueToCredit}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      setCreditAccounts(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  useEffect(() => {
    fetchRVList();
    fetchInitialDrList();
  }, [rvType]);

  const fetchRVList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const apiUrlRV = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/${rvType}/-`;
    try {
      const response = await axios.get(apiUrlRV);
      const data = response.data;
      console.log("fetched RV List when > 0 :", data);
      const rvNumberFromAPI = data[0].NEXT_NO;
      console.log("Rv No From API", rvNumberFromAPI);
      if (rvNumberFromAPI > 0) {
        console.log("RV Number Greater than 0", rvNumberFromAPI > 0);
        setRVnoFromAPI(rvNumberFromAPI);
      } else {
        let apiUrl2 = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/RV/-`;
        try {
          const response = await axios.get(apiUrl2);
          const data = response.data;
          console.log("fetched RV List when < 0 :", data);
          const rvNumberFromAPI2 = data[0].NEXT_NO;
          setRVnoFromAPI(rvNumberFromAPI2);
          setRvType("RV");
        } catch (err) {
          console.error("Error while fetching RV List", err);
        }
      }
    } catch (err) {
      console.error("Error while fetching RV List", err);
    }
  };

  const fetchInitialDrList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/Scrn_code/RV/-/${currentSelectedDepartment}/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("setInitialDrList :", data);
      setInitialDrList(data);

      setAccountByPaymentMethod(paymentMethod, data);
    } catch (err) {
      console.error("Error while fetching RV List", err);
    }
  };

  console.log("paymentMethod changed", paymentMethod);

  const setAccountByPaymentMethod = (paymentMethod, data) => {
    let scrnCode = "";

    switch (paymentMethod.toLowerCase()) {
      case "cash":
        scrnCode = "RV-CA-D";
        break;
      case "bank":
        scrnCode = "RV-BA-D";
        break;
      case "cheque":
        scrnCode = "RV-CQ-D";
        break;
      case "creditcard":
        scrnCode = "RV-CC-D";
        break;
      default:
        console.log("Unknown payment method");
        return;
    }

    const account = data.find((item) => item.Scrn_code === scrnCode);

    if (account && account.ACCOUNT) {
      setSelectedDr(account.ACCOUNT);
      setSelectedDrDesc(account.accdesc);
      console.log(`${paymentMethod} account selected:`, account.ACCOUNT);
    } else {
      console.log(
        `${paymentMethod} account not found or no account number available`,
      );
    }
  };

  const toggleRow = (voucherNo) => {
    setSelectedRows((prev) =>
      prev.includes(voucherNo)
        ? prev.filter((id) => id !== voucherNo)
        : [...prev, voucherNo],
    );
  };

  const handleChangePayment = (e) => {
    console.log("value changed to:", e.target.value);
    setPaymentMethod(e.target.value);
  };

  const clearCreditAccounts = () => {
    setInputCreditValue("-");
    setSelectedCreditAccount(null);
  };
  const clearDebitAccounts = () => {
    // setInputDebitValue("-");
    setInputDebitValue("");
    setSelectedDebitAccount(null);
  };

  const clearDifferenceAccounts = () => {
    setinputDifferenceValue("-");
    setselectedDifferenceAccount(null);
  };

  const handleChangeRVType = (e) => {
    const newValue = e.target.value;
    console.log("newValue:", newValue);
    if (newValue === "bank") {
      setRvType("RV-B");
    } else if (newValue === "creditcard") {
      setRvType("RV-B");
    } else if (newValue === "cheque") {
      setRvType("RV-Q");
    } else if (newValue === "cash") {
      setRvType("RV-C");
    }
  };
  useEffect(() => {
    console.log("rvType:", rvType);
  }, [rvType]);

  const formatBalance = (balance) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  // useEffect(() => {
  //   setInputDebitValue(
  //     selectedDebitAccount
  //       ? `${selectedDebitAccount.ACCOUNT} | ${
  //           selectedDebitAccount.DESCRIPTION || ""
  //         }`
  //       : `${selectedDr || ""} | ${selectedDrDesc || ""}`
  //   );
  // }, [selectedDebitAccount, selectedDr, selectedDrDesc]);

  useEffect(() => {
    if (selectedDr || selectedDrDesc) {
      // Priority: if user changes selectedDr/Desc, always update
      setInputDebitValue(`${selectedDr || ""} | ${selectedDrDesc || ""}`);
    } else if (selectedDebitAccount) {
      // Otherwise, fallback to the selected account object
      setInputDebitValue(
        `${selectedDebitAccount.ACCOUNT} | ${selectedDebitAccount.DESCRIPTION || ""
        }`,
      );
    } else {
      setInputDebitValue("");
    }
  }, [selectedDebitAccount, selectedDr, selectedDrDesc]);

  // useEffect(() => {
  //   console.log("useEffect triggered:", {
  //     selectedDr: `"${selectedDr}"`,
  //     selectedDrDesc: `"${selectedDrDesc}"`,
  //     selectedDebitAccount,
  //     condition1: !!(selectedDr || selectedDrDesc),
  //     condition2: !!selectedDebitAccount,
  //   });

  //   // ... rest of your logic
  // }, [selectedDebitAccount, selectedDr, selectedDrDesc]);

  // const prevDr = useRef(selectedDr);
  // const prevDrDesc = useRef(selectedDrDesc);

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     if (selectedDr || selectedDrDesc) {
  //       setInputDebitValue(`${selectedDr || ""} | ${selectedDrDesc || ""}`);
  //     } else if (selectedDebitAccount) {
  //       setInputDebitValue(
  //         `${selectedDebitAccount.ACCOUNT} | ${selectedDebitAccount.DESCRIPTION || ""}`
  //       );
  //     } else {
  //       setInputDebitValue("");
  //     }
  //   }, 0); // run after the current event loop

  //   return () => clearTimeout(timeout);
  // }, [selectedDebitAccount, selectedDr, selectedDrDesc]);

  const types = [
    { name: "All", icon: Home },
    { name: "Cash", icon: DollarSign },
    { name: "Bank", icon: Landmark },
    { name: "PDC", icon: TicketCheck },
    { name: "Customers", icon: Users },
    { name: "Suppliers", icon: Package },
    { name: "Assets", icon: Briefcase },
    { name: "Liabilities", icon: CreditCard },
    { name: "Income", icon: TrendingUp },
    { name: "Expenses", icon: TrendingDown },
    { name: "InExpenses", icon: HandCoins },
    { name: "InterCompany", icon: Building2, disable: false },
  ];

  const typeMapping = {
    cash: "Cash",
    cheque: "PDC",
    bank: "Bank",
    creditcard: "Bank",
  };

  const dropdowndebitRef = useRef(null);
  const dropdowncreditRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdowndebitRef.current &&
        !dropdowndebitRef.current.contains(event.target)
      ) {
        setDebitDropdownOpen(false);
      }
      if (
        dropdowncreditRef.current &&
        !dropdowncreditRef.current.contains(event.target)
      ) {
        setCreditDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAmountChange = (index, value) => {
    const updated = [...amounts];
    updated[index] = Number(value) || 0; // ensure number
    setAmounts(updated);
  };

  const handleSelectToggle = (index, checked, balAmt) => {
    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      return updated;
    });
    setAmounts((prev) => {
      const updated = [...prev];
      updated[index] = checked ? balAmt : "";
      return updated;
    });
  };

  useEffect(() => {
    console.log("amounts:", amounts);
    const totalAmount = amounts?.reduce((acc, val) => acc + Number(val), 0);
    console.log("totalAmount:", totalAmount);

    setSumOfAmounts(totalAmount);
  }, [amounts]);

  useEffect(() => {
    if (Array.isArray(outstandingRV)) {
      setAmounts(outstandingRV.map((row) => row?.AMOUNT || ""));
    }
  }, [outstandingRV]);

  const onSaveReceipt = () => {
    console.log("onSaveReceipt called");
    if (!commentsInput || commentsInput.trim() === "") {
      alert("Please enter comments before saving.");
      return;
    }
    if (isChequeInvalid) {
      alert("Please fill Cheque No, Date and Bank");
      return;
    }
    if (!amtRecieved || Number(amtRecieved) === 0) {
      alert("Amount received cannot be zero.");
      return;
    }
    if (isOnAc) {
      receiptSaveAPI();
      return;
    }
    if (Math.abs(Number(differenceAmount || 0)) < 0.001) {
      receiptSaveAPI();
    } else if (transferAccountBlock && inputDifferenceValue.length > 0) {
      receiptSaveAPI();
    } else {
      setTransferAccountPopup(true);
      // onConfirmPaymentTransferPopup();
    }
  };

  const onConfirmPaymentTransferPopup = () => {
    // API to save payment
    setTransferAccountBlock(true);
    setTransferAccountPopup(false);
  };

  const receiptSaveAPI = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;
    // const salesman_from_local_storage =  currentUser_from_local_storage?.sales_man

    const buildReceiptPayload = () => {
      let currentUser_from_local_storage = localStorage.getItem("currentUser")
        ? localStorage.getItem("currentUser")
        : "-";

      const user_from_local_storage = JSON.parse(
        localStorage.getItem("currentUser") || "[]",
      )[0]?.user;
      console.log(user_from_local_storage); // "ADMIN"

      const commonFields = {
        cmpcode: company_code_from_local_storage,
        operation: isEditMode ? "EDIT" : "ENTRY",
        JVTYPE: rvType || "",
        TYPE_NO: rvnoFromAPI || "",
        JVDATE: jvDate || "",
        CUST_ACC: inputCreditValueAccount || "",
        ACCDESC: "", // will be overridden per entry
        AMOUNT: "0", // will be overridden per entry
        DESCRIPT: descriptionInput || "",
        DEPTNO: currentSelectedDepartment_from_local_storage || "",
        COMMENTS: commentsInput || "",
        USERID: user_from_local_storage?.trim() || "",
        job_code: jobCodeInput || "",
        sman_code: selectedSalesman?.EMP_ID || "",
        costc: cCenterInput || "",
        chqno: chequeNO || "",
        chqdate: chequeDate || "",
        rate: (selectedCurrency || currencies[0])?.rate?.toFixed(6) || "",
        pdcstatus: "",
        pdc_acc: "", // will be overridden
        reason: commentsInput || "",
        account: "", // will be overridden
        jvnum: rvnoFromAPI || "",
        ref: "",
        entry_ref: descriptionInput,
        type: "", // will be overridden
        curno: (selectedCurrency || currencies[0])?.curno || "",
        curamount: Number(amtRecieved).toFixed(2) || "",
        user_id: user_from_local_storage?.trim() || "",
        accountype: "", // will be overridden
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: chequeBank || "",
        due_date: currentDate || "",
        doc_date: currentDate || "",
        month: "0",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: cCenterInput || "",
        ttref: "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: "0",
        COSTCODE: cCenterInput || "",
      };

      const bcAmount =
        amtRecieved * ((selectedCurrency || currencies[0])?.rate ?? 1);
      // Debit entry (credit side equivalent in Payment)
      const debitEntry = {
        ...commonFields,
        ACCDESC: inputCreditValueDescription || "",
        AMOUNT: Number(bcAmount).toFixed(2) || "",
        curamount: Number(amtRecieved).toFixed(2) || "",
        pdc_acc: inputCreditValueAccount || "",
        account: selectedDr || inputDebitValueAccount || "",
        ref: isOnAc ? "ON A/C" : rvnoFromAPI + "" || "",
        type: "D",
        curno: (selectedCurrency || currencies[0])?.curno || "",
        accountype: "1",
      };

      // Credit entries
      let creditEntries = [];

      const defaultCurrency =
        currencies.find((c) => c.rate === 1) || currencies[0];
      if (isOnAc) {
        // When On A/C is checked, create a single credit entry with the full amount
        creditEntries = [
          {
            ...commonFields,
            ACCDESC: inputCreditValueDescription || "",
            AMOUNT: Number(bcAmount).toFixed(2) || "",
            curamount: Number(amtRecieved).toFixed(2) || "",
            pdc_acc: selectedDr || inputDebitValueAccount || "",
            account: inputCreditValueAccount || "",
            ref: "ON A/C",
            type: "C",
            rate: (selectedCurrency || currencies[0])?.rate?.toFixed(6) || "",
            curno: (selectedCurrency || currencies[0])?.curno || "",
            accountype: "2",
          },
        ];
      } else {
        // Normal flow - create credit entries from outstanding invoices
        creditEntries = (outstandingRV || [])
          .map((outRV, index) => {
            const amount = Number(amounts[index]);
            if (!amount || amount === 0) return null;
            const billRate =
              currencies.find((c) => c.curno === outRV?.CUR)?.rate || 1;

            return {
              ...commonFields,
              ACCDESC: outRV?.DESCR || "",
              AMOUNT: Number(amount).toFixed(2) || "",
              curamount: (amount / billRate).toFixed(2) || "",
              pdc_acc: selectedDr || inputDebitValueAccount || "",
              account: inputCreditValueAccount || "",
              ref: outRV?.INV + "" || "",
              type: "C",
              rate: billRate.toFixed(6) || "",
              curno: outRV?.CUR || "",
              accountype: "2",
            };
          })
          .filter(Boolean);
      }

      // Difference entry (only for non-OnAc receipts)
      let differenceEntry = null;
      if (!isOnAc && transferAccountBlock && inputDifferenceValue.length > 0) {
        const diffType2 = differenceAmount < 0 ? "C" : "D";
        const bcDiffAmt =
          Math.abs(differenceAmount) *
          ((selectedCurrency || currencies[0])?.rate ?? 1);
        differenceEntry = {
          ...commonFields,
          ACCDESC: inputDifferenceValueDescription || "",
          AMOUNT: Number(differenceAmount).toFixed(2) || "",
          curamount: Number(bcDiffAmt).toFixed(2) || "",
          pdc_acc: inputDebitValueAccount || "",
          account: inputDifferenceValueAccount || "",
          ref: "ON A/C",
          type: diffType2,
          rate: diffType2 === "D" ? ((selectedCurrency || currencies[0])?.rate?.toFixed(6) || "") : "1.000000",
          curno: diffType2 === "D" ? ((selectedCurrency || currencies[0])?.curno || "") : (defaultCurrency?.curno || ""),
          accountype: "3",
        };
      }

      return differenceEntry
        ? [debitEntry, ...creditEntries, differenceEntry]
        : [debitEntry, ...creditEntries];
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;

    try {
      const finalReceiptpayload = buildReceiptPayload();
      console.log("Final receipt payload:", finalReceiptpayload);
      console.log("API URL:", apiUrl);

      const response = await axios.post(apiUrl, finalReceiptpayload, config);

      console.log("Receipt data Saved:", response.data);
      const data = response?.data;
      setVNO(data?.vno);
      setReceiptSavedPopup(true);
    } catch (error) {
      console.log("error while saving reciept", error);
      alert("Error saving receipt (see console)");
    }
  };

  const onCloseTransferPopup = () => {
    setTransferAccountPopup(false);
  };

  const onCloseSaveRVPopup = () => {
    setReceiptSavedPopup(false);
    resetForm();
    onNewReceipt();
  };

  const requestCurrencyList = async ({ url, method, timeout }) => {
    return axios({
      url,
      method,
      timeout,
    }).then((res) => res.data);
  };

  const fetchCurrencyList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    try {
      const response = await requestCurrencyList({
        url: url,
        method: "GET",
        timeout: 10000,
      });

      console.log("Response", response);
      setCurrencies(response || []);

      // Default currency from the fetched data
      if (response && response.length > 0) {
        const defaultCurrency =
          response?.find((item) => item?.rate === 1) || response[0];
        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  const filteredSearchedDebitAccounts = searchDebitAccountTerm
    ? filteredAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchDebitAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchDebitAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const filteredSearchedAccounts = searchCreditAccountTerm
    ? filteredAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchCreditAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchCreditAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const filteredSearchedDifferenceAccounts = searchDifferenceAccountTerm
    ? filteredCreditAccounts.filter(
      (acc) =>
        acc.ACCOUNT.toString()
          .toLowerCase()
          .includes(searchDifferenceAccountTerm.toLowerCase()) ||
        acc.DESCRIPTION.toLowerCase().includes(
          searchDifferenceAccountTerm.toLowerCase(),
        ),
    )
    : filteredAccounts;

  const navigate = useNavigate();

  const onReceiptView = async () => {
    navigate("/recieptView");
  };

  const onNewReceipt = async () => {
    setIsEditMode(false);
    navigate("/reciept");

    setInputCreditValue("");
    setSelectedCreditAccount(null);
    setInputCreditValueAccount("");
    setInputCreditValueDescription("");
  };

  const debitSearchInputRef = useRef(null);
  const creditSearchInputRef = useRef(null);
  const differenceSearchInputRef = useRef(null);

  useEffect(() => {
    if (debitModalOpen && debitSearchInputRef.current) {
      debitSearchInputRef.current.focus();
    }
  }, [debitModalOpen]);
  useEffect(() => {
    if (creditModalOpen && creditSearchInputRef.current) {
      creditSearchInputRef.current.focus();
    }
  }, [creditModalOpen]);
  useEffect(() => {
    if (differenceModalOpen && differenceSearchInputRef.current) {
      differenceSearchInputRef.current.focus();
    }
  }, [differenceModalOpen]);

  // console.log(
  //   "🚀 ~ Reciept ~ inputCreditValueAccount:",
  //   inputCreditValueAccount
  // );
  useEffect(() => {
    // inputCreditValueAccount
    console.log(
      "🚀 ~ Reciept ~ inputCreditValueAccount:",
      inputCreditValueAccount,
    );
    console.log(
      "🚀 ~ Reciept ~ inputDebitValueAccount:",
      inputDebitValueAccount,
    );
  }, [inputCreditValueAccount, inputDebitValueAccount]);

  const handleCrAccountSelect = (data) => {
    console.log("Cr data:", data.ACCOUNT);
    // setAccount(data.ACCOUNT);
    setSelectedCreditAccount(data);
    setInputCreditValueAccount(data.ACCOUNT);
    setInputCreditValueDescription(data.DESCRIPTION);
    setInputCreditValue(`${data.ACCOUNT} - ${data.DESCRIPTION}`);
    setSearchCreditAccountTerm("");
    setCreditModalOpen(false);
    setDebitDropdownOpen(false);
  };

  const handleDrAccountSelect = (data) => {
    console.log("Dr data:", data);
    // setAccount(data.ACCOUNT);
    setSelectedDr("");
    setSelectedDrDesc("");
    setInputDebitValue(`${data.ACCOUNT} - ${data.DESCRIPTION}`);
    setInputDebitValueAccount(data.ACCOUNT);
    setInputDebitValueDescription(data.DESCRIPTION);
    setSelectedDebitAccount(data);
    setSearchDebitAccountTerm("");
    setDebitModalOpen(false);
  };

  const handleonAccountSelect = (data) => {
    console.log("Diff data:", data.ACCOUNT);
    setDifferenceModalOpen(false);
    setinputDifferenceValue(`${data.ACCOUNT} | ${data.DESCRIPTION}`);
    setinputDifferenceValueAccount(data.ACCOUNT);
    setinputDifferenceValueDescription(data.DESCRIPTION);
    setselectedDifferenceAccount(data);
    setSearchDifferenceAccountTerm("");
  };

  const isChequeRequired = paymentMethod === "cheque";

  const isChequeInvalid =
    isChequeRequired && (!chequeNO || !chequeDate || !chequeBank);

  return (
    <div className="p-6  rounded-lg  mx-auto relative ">
      {/* <div className="bg-[#F8F8F8] sticky top-0 mb-4 z-20"> */}
      <div className="bg-[#F8F8F8] sticky top-0 mb-4">
        <div className="justify-between   flex items-end mr-[9.5%] ">
          <div className="flex justify-between gap-8 ">
            <h2 className="text-xl  text-gray-800">
              {isEditMode ? "Receipt Edit" : "Receipt"}{" "}
            </h2>

            <div className="flex w-full items-end justify-center gap-6">
              <div className="flex items-end justify-center w-full">
                <div className="flex justify-center items-center select-none space-x-6">
                  {/* Cash */}
                  <label className="relative cursor-pointer">
                    <input
                      type="radio"
                      name="payment"
                      value="cash"
                      checked={selected === "cash"}
                      onChange={handleChange}
                      className="peer absolute opacity-0 w-0 h-0"
                    />
                    <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white border border-gray-300 transition duration-150 ease-in-out peer-checked:border-blue-500 peer-checked:bg-blue-500 peer-checked:text-white">
                      <DollarSign className="w-5 h-5 peer-checked:text-white" />
                      <span className="text-[16px]  peer-checked:text-white">
                        Cash
                      </span>
                    </span>
                  </label>

                  {/* Bank */}
                  <label className="relative cursor-pointer">
                    <input
                      type="radio"
                      name="payment"
                      value="bank"
                      checked={selected === "bank"}
                      onChange={handleChange}
                      className="peer absolute opacity-0 w-0 h-0"
                    />
                    <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white border border-gray-300 transition duration-150 ease-in-out peer-checked:border-blue-500 peer-checked:bg-blue-500 peer-checked:text-white">
                      <Landmark className="w-5 h-5 peer-checked:text-white" />
                      <span className="text-[16px]  peer-checked:text-white">
                        Bank
                      </span>
                    </span>
                  </label>

                  {/* Cheque */}
                  <label className="relative cursor-pointer">
                    <input
                      type="radio"
                      name="payment"
                      value="cheque"
                      checked={selected === "cheque"}
                      onChange={handleChange}
                      className="peer absolute opacity-0 w-0 h-0"
                    />
                    <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white border border-gray-300 transition duration-150 ease-in-out peer-checked:border-blue-500 peer-checked:bg-blue-500 peer-checked:text-white">
                      <FileText className="w-5 h-5 peer-checked:text-white" />
                      <span className="text-[16px]  peer-checked:text-white">
                        Cheque
                      </span>
                    </span>
                  </label>

                  {/* Credit Card */}
                  <label className="relative cursor-pointer">
                    <input
                      type="radio"
                      name="payment"
                      value="creditcard"
                      checked={selected === "creditcard"}
                      onChange={handleChange}
                      className="peer absolute opacity-0 w-0 h-0"
                    />
                    <span className="flex flex-col items-center justify-center w-20 min-h-20 rounded-lg border-2 border-gray-300 bg-white border border-gray-300 transition duration-150 ease-in-out peer-checked:border-blue-500 peer-checked:bg-blue-500 peer-checked:text-white">
                      <CreditCard className="w-5 h-5 peer-checked:text-white" />
                      <span className="text-[14.5px]  peer-checked:text-white">
                        Credit Card
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-4">
            {isEditMode && (
              <button
                onClick={onNewReceipt}
                className="relative bg-green-500 text-white font-medium text-[17px] px-4 py-[0.35em] pl-5 h-[2.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group hover:bg-green-600"
              >
                <span className="mr-10">New</span>

                <div className="absolute right-[0.3em] bg-white h-[2.2em] w-[2.2em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
                  <FaPlus className="text-green-500" />
                </div>
              </button>
            )}
            <button
              onClick={onReceiptView}
              className="relative bg-yellow-500 text-white font-medium text-[17px] px-4 py-[0.35em] pl-5 h-[2.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
            >
              <span className="mr-10">View</span>
              <div className="absolute right-[0.3em] bg-white h-[2.2em] w-[2.2em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
                <FaEye className=" text-yellow-500 " />
              </div>
            </button>
          </div>
        </div>

        {/* <div className="flex justify-center items-center grid grid-cols-2 gap-4 divide-x-4 divide-gray-200 max-w-6xl"> */}
        <div className="bg-white text-black border border-[#CCC5B7] p-4 rounded-lg flex justify-center items-center grid grid-cols-2 gap-4 divide-x-2 divide-white max-w-7xl  mx-auto mt-2">
          <div className="grid grid-cols-3 gap-2  ">
            <div className="w-40 mr-4 flex justify-left items-center border border-gray-300 rounded mt-6 mb-1">
              <label className="px-4 text-sm font-medium flex items-center gap-1">
                {/* <AiOutlineNumber className="w-4 h-4 text-gray-600" /> */}
                RV No :
              </label>
              <p className=" bg-transparent rounded px-2 py-1 text-gray-900">
                {rvnoFromAPI}
              </p>
            </div>

            <div className=" ">
              <label className="text-sm font-medium flex items-center gap-1">
                <FaCalendarAlt className="w-4 h-4 text-gray-600" />
                Date
              </label>
              <input
                type="date"
                value={jvDate}
                onChange={(e) => setJvDate(e.target.value)} // update state
                className="w-full bg-white  text-gray-700 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 px-2 py-1 rounded mt-1"
              />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                <FaUserTie className="w-4 h-4 text-gray-600" />
                Salesman
              </label>
              <select
                name="salesman"
                value={selectedSalesman?.EMP_ID || ""}
                onChange={(e) => {
                  const selected = salesmanList.find(
                    (s) => s.EMP_ID === e.target.value,
                  );
                  setSelectedSalesman(selected);
                }}
                className="w-full px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option className="" value="">
                  {" "}
                  Select Salesman{" "}
                </option>
                {Array.isArray(salesmanList) &&
                  salesmanList.map((salesMan) => (
                    <option key={salesMan.EMP_ID} value={salesMan.EMP_ID}>
                      {salesMan.NAME}
                    </option>
                  ))}
              </select>
            </div>
            <div class=" w-30  flex justify-center items-end mb-2 gap-2">
              <input
                class="shadow-sm border-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:scale-100 rounded-md transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-6 h-6"
                type="checkbox"
              />
              <label class=" text-sm font-normal">More Debit</label>
            </div>
            {/* <div class="ml-4 w-40  flex justify-center items-end mb-2 gap-2">
            <input
              class="shadow-sm border-gray-400 focus:ring-blue-500 focus:border-blue-500 dark:scale-100 rounded-md transition-all duration-500 ease-in-out dark:hover:scale-110 dark:checked:scale-100 w-6 h-6"
              type="checkbox"
            />
            <label class=" text-md font-medium">More Debit</label>
          </div> */}

            <div ref={dropdowndebitRef} className=" col-span-4 relative">
              <label className="text-sm font-medium flex items-center gap-1">
                <FaMoneyBillWave className="w-4 h-4 text-gray-500" />
                Dr
              </label>
              <div className="flex items-center bg-white w-full border border-gray-300 rounded px-3 py-2">
                <input
                  type="text"
                  value={inputDebitValue}
                  // onClick={(e) => {
                  //   // setDebitDropdownOpen(true);
                  // }}
                  onChange={(e) => {
                    setDebitDropdownOpen(true);
                    setInputDebitValue(e.target.value);
                    setSelectedDebitAccount(null);
                  }}
                  placeholder="Enter Debit Account"
                  className="w-full px-2 py-1 rounded outline-none border-none  focus:ring-0 text-gray-900"
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      // e.preventDefault();
                      setDebitModalOpen(true);
                      setDebitDropdownOpen(false);
                    }
                  }}
                />

                {(selectedDebitAccount || inputDebitValue) && (
                  <button
                    type="button"
                    className="ml-2 text-gray-700 hover:text-gray-900"
                    onClick={clearDebitAccounts}
                  >
                    <ClearIcon fontSize="small" />
                  </button>
                )}
              </div>

              {/* Dropdown */}
              {debitDropdownOpen &&
                inputDebitValue?.length > 0 &&
                filteredAccounts?.length > 0 && (
                  <ul
                    className="absolute bg-white border border-gray-300 w-full mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                  // onMouseDown={(e) => e.preventDefault()}
                  >
                    {filteredAccounts?.map((acc, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          setSelectedDr("");
                          setSelectedDrDesc("");
                          setDebitDropdownOpen(false);
                          // setInputCreditValue(`${acc.ACCOUNT} - ${acc.DESCRIPTION}`);
                          setInputDebitValue(
                            `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                          );
                          setInputDebitValueAccount(acc.ACCOUNT);
                          setInputDebitValueDescription(acc.DESCRIPTION);
                          setSelectedDebitAccount(acc);
                          // sendAccountToParent(acc.ACCOUNT);

                          fetchOutstandingRV(acc?.ACCOUNT);
                        }}
                        className="px-3 py-2 text-sm flex items-center justify-left gap-6 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0 "
                      >
                        <div className="text-sm text-white px-2 py-0.5 rounded-xl bg-blue-500">
                          {acc.ACCOUNT}
                        </div>
                        <div className="font-medium text-gray-900 text-sm line-clamp-2">
                          {acc.DESCRIPTION}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
            </div>

            <div ref={dropdowncreditRef} className="col-span-4 relative">
              <label className="text-sm font-medium flex items-center gap-1">
                <FaUniversity className="w-4 h-4 text-gray-500" />
                Cr
              </label>
              <div
                ref={crInputWrapperRef}
                className={`flex items-center border border-gray-300 w-full   rounded px-3 py-2 ${crInputWrapperFocus
                  ? "ring-2 ring-blue-500 border-blue-500"
                  : ""
                  }`}
              >
                <input
                  ref={crInputRef}
                  type="text"
                  value={inputCreditValue === "-" ? "" : inputCreditValue}
                  // onClick={(e) => {
                  //   setCreditDropdownOpen(true);
                  // }}

                  onChange={(e) => {
                    // allow user typing -> overrides initialDr display
                    setCreditDropdownOpen(true);
                    setInputCreditValue(e.target.value);
                    setSelectedCreditAccount(null); // reset selection if user types manually
                  }}
                  placeholder="Enter Credit Account"
                  className="w-full px-2 py-1  rounded outline-none  border-none focus:ring-0 text-gray-900"
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      // e.preventDefault();
                      setInputCreditValue("-");
                      setCreditModalOpen(true);
                      setCreditDropdownOpen(false);
                    }
                  }}
                />

                {(selectedCreditAccount ||
                  (inputCreditValue && inputCreditValue !== "-")) && (
                    <button
                      type="button"
                      className="ml-2 text-gray-700 hover:text-gray-900"
                      onClick={clearCreditAccounts}
                    >
                      <ClearIcon fontSize="small" />
                    </button>
                  )}
              </div>
              {/* Dropdown */}
              {creditDropdownOpen &&
                inputCreditValue?.length > 0 &&
                filteredCreditAccounts?.length > 0 && (
                  <ul
                    className="absolute bg-white border border-gray-300 mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                  // onMouseDown={(e) => e.preventDefault()}
                  >
                    {filteredCreditAccounts?.map((acc, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          setCreditDropdownOpen(false);
                          setInputCreditValue(
                            `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                          );
                          setInputCreditValueAccount(acc.ACCOUNT);
                          setInputCreditValueDescription(acc.DESCRIPTION);
                          setSelectedCreditAccount(acc);
                          // sendAccountToParent(acc.ACCOUNT);
                        }}
                        className="px-3 py-2 text-sm flex items-center justify-left gap-6 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0 "
                      >
                        <div className="text-sm text-white px-2 py-0.5 rounded-xl text-gray-700 bg-blue-500">
                          {acc.ACCOUNT}
                        </div>
                        <div className="font-medium text-gray-900 text-sm text-gray-700 line-clamp-2">
                          {acc.DESCRIPTION}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
            </div>

            <div className="col-span-4 row-span-3">
              <label className="text-sm font-medium flex items-center gap-1">
                <MdOutlineDescription className="text-gray-500 w-4 h-4" />
                Description
              </label>
              <textarea
                className="w-full text-gray-700  border border-gray-300 px-2 py-1 rounded mt-1 "
                value={descriptionInput}
                onChange={(e) => setDescriptionInput(e.target.value)}
              />
            </div>
            {/* <div className="flex-1">
            <label className="block text-sm font-medium  mb-1">Salesman</label>
            <select
              name="salesman"
              value={selectedSalesman?.EMP_ID || ""}
              onChange={(e) => {
                const selected = salesmanList.find(
                  (s) => s.EMP_ID === e.target.value
                );
                setSelectedSalesman(selected);
              }}
              className="w-full px-3 py-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option className="" value="">
                {" "}
                Select Salesman{" "}
              </option>
              {Array.isArray(salesmanList) &&
                salesmanList.map((salesMan) => (
                  <option key={salesMan.EMP_ID} value={salesMan.EMP_ID}>
                    {salesMan.NAME}
                  </option>
                ))}
            </select>
          </div> */}

            {paymentMethod === "cash" ? (
              ""
            ) : paymentMethod === "creditcard" ? (
              <div className="col-span-[1.5]">
                <label className="text-sm font-medium">Credit Card No.</label>
                <input
                  className="w-full border border-gray-300   px-2 py-1 rounded mt-1"
                  onChange={(e) => setCreditCardNo(e.target.value)}
                  value={creditCardNo}
                />
              </div>
            ) : (
              isChequeRequired && (
                <div className="col-span-4">
                  <div className="flex items-center gap-4">
                    <div>
                      <label className="text-sm font-medium">
                        Cheque <span className="text-red-500">*</span>
                      </label>
                      <input
                        value={chequeNO}
                        onChange={(e) => setChequeNO(e.target.value)}
                        className={`w-full px-2 py-1 rounded mt-1 border ${!chequeNO && isChequeRequired
                          ? "border-red-500"
                          : "border-gray-300"
                          }`}
                        required={isChequeRequired}
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium">
                        Cheque Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        value={chequeDate}
                        onChange={(e) => setChequeDate(e.target.value)}
                        className={`w-full px-2 py-1 rounded mt-1 border ${!chequeDate && isChequeRequired
                          ? "border-red-500"
                          : "border-gray-300"
                          }`}
                        required={isChequeRequired}
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium">
                        Bank <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={chequeBank}
                        onChange={(e) => setChequeBank(e.target.value)}
                        className={`w-full px-2 py-1 rounded mt-1 border ${!chequeBank && isChequeRequired
                          ? "border-red-500"
                          : "border-gray-300"
                          }`}
                        required={isChequeRequired}
                      />
                    </div>
                  </div>
                </div>
              )
            )}
          </div>

          {/* <div class="border-r-4 border-indigo-500 ..."></div> */}

          <div className="grid grid-cols-2 gap-4 my-2 pl-4">
            <div>
              <label className="text-sm font-medium flex items-center gap-1">
                <FaFileInvoiceDollar className="w-4 h-4 text-gray-600" />
                Amt. Received
              </label>
              <input
                ref={onAmtRecievedRef}
                type="text"
                className="w-full text-right text-gray-700  border border-gray-300  px-2 py-1 rounded mt-1"
                value={amtRecieved}
                onChange={(e) => setAmtRecieved(e.target.value)}
              />
            </div>

            <div className="flex items-center gap-2 mb-1">
              <div className="flex-1">
                <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                  <BsCurrencyExchange className="w-4 h-4 text-gray-600" />
                  Foreign Currency
                </label>
                <select
                  name="fc"
                  value={selectedCurrency?.curno || ""}
                  onChange={(e) => {
                    const selected = currencies.find(
                      (c) => c.curno === e.target.value,
                    );
                    setSelectedCurrency(selected);
                    // setInvoiceData((prev) => ({
                    //   ...prev,
                    //   currency: selected?.curno || "",
                    //   currencyRate: selected?.rate || 1,
                    // }));
                  }}
                  className="w-full px-3 py-2 text-sm bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {currencies?.map((currency) => (
                    <option key={currency?.curno} value={currency?.curno}>
                      {currency?.curno} - {currency?.cur?.trim()}
                    </option>
                  ))}
                </select>
              </div>
              <div className="px-3 py-2 bg-orange-50 border border-orange-300 rounded-md mt-6">
                <span className="text-sm font-bold text-orange-600">
                  {selectedCurrency?.rate?.toFixed(6)}
                </span>
              </div>
            </div>

            <div>
              {/* <label className="text-sm font-medium">Ref No</label>
          <input type="text" className="w-full border px-2 py-1 rounded mt-1" /> */}
            </div>
            <div className="flex items-center gap-2 mt-1">
              {/* <div>
              <label className="text-sm font-medium">BCur Amt.</label>
              <input
                value={amtRecieved * selectedCurrency?.rate?.toFixed(6)}
                readOnly
                type="number"
                className="w-full text-right text-gray-700  border border-gray-300  px-2 py-1 rounded mt-1"
              />
            </div> */}

              <div className="border border-gray-300  rounded   flex justify-center items-center mt-4">
                <label className="text-sm font-medium">BCur Amt.</label>
                <input
                  readOnly
                  value={amtRecieved * selectedCurrency?.rate?.toFixed(2)}
                  className="cursor-not-allowed w-[55%] border-none text-right bg-transparent  px-2 py-1 rounded  "
                />
              </div>

              <label className="text-xs font-medium mt-6 ml-4">On A/C</label>
              <div className="flex items-center gap-2 mt-6">
                <label className="relative inline-block w-[3.5em] h-[2em]">
                  <input
                    type="checkbox"
                    className="peer sr-only"
                    checked={isOnAc}
                    onChange={(e) => setIsOnAc(e.target.checked)}
                  />
                  <span
                    className="
          absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
          after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
          after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
          after:transition-all after:duration-300 after:ease-in-out
          after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
          peer-checked:bg-blue-500
          peer-checked:after:translate-x-[1.5em]
          peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
          peer-active:after:w-[3em]
          peer-checked:peer-active:after:translate-x-[0.5em]
        "
                  ></span>
                </label>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-1">
              <div>
                <label className="text-sm font-medium flex items-center gap-1">
                  <MdWork className="w-4 h-4 text-gray-600" />
                  Job Code
                </label>{" "}
                <input
                  value={jobCodeInput}
                  onChange={(e) => {
                    setJobCodeInput(e.target.value);
                  }}
                  className="w-full text-gray-700   border border-gray-300  px-2 py-1 rounded mt-1"
                />
              </div>
              <div>
                <label className="text-sm font-medium flex items-center gap-1">
                  <HiOutlineOfficeBuilding className="w-4 h-4 text-gray-600" />
                  C.Center
                </label>
                <input
                  value={cCenterInput}
                  onChange={(e) => {
                    setcCenterInput(e.target.value);
                  }}
                  className="w-full text-gray-700  border border-gray-300  px-2 py-1 rounded mt-1"
                />
              </div>
            </div>
            <div>
              {/* <label className="text-sm font-medium">Amount (INR)</label>
          <input type="number" className="w-full border px-2 py-1 rounded mt-1" /> */}
            </div>
            <div className="col-span-3">
              {/* <div className="col-span-3 row-span-3"> */}
              <div>
                <label className="text-sm font-medium flex items-center gap-1">
                  <FaCommentDots className="w-4 h-4 text-gray-600" />
                  Comments <span className="text-red-500">*</span>
                </label>
                <textarea
                  className="w-full text-gray-700  border border-gray-300  px-2 py-1 rounded mt-1"
                  value={commentsInput}
                  onChange={(e) => setCommentsInput(e.target.value)}
                />
              </div>
              <div className="flex items-center gap-4">
                {/* Debit */}
                <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                  <label className="text-sm font-medium">Debit :</label>
                  <input
                    readOnly
                    value={(
                      amtRecieved * (selectedCurrency?.rate ?? 1)
                    )?.toFixed(2)}
                    className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                  />
                </div>

                {/* Credit */}
                {!isOnAc ? (
                  <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                    <label className="text-sm font-medium">Credit :</label>
                    <input
                      readOnly
                      value={
                        // transferAccountBlock
                        //   ? sumOfAmounts + Number(differenceAmount || 0)
                        // :
                        sumOfAmounts?.toFixed(2)
                      }
                      className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                    />
                  </div>
                ) : (
                  <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                    <label className="text-sm font-medium">Credit :</label>
                    <input
                      readOnly
                      value={(
                        amtRecieved * (selectedCurrency?.rate ?? 1)
                      )?.toFixed(2)}
                      className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                    />
                  </div>
                )}

                {/* Difference */}
                {!isOnAc ? (
                  <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                    <label className="text-sm font-medium">Difference :</label>

                    <input
                      readOnly
                      value={
                        // transferAccountBlock
                        //   ? (
                        //       Number(sumOfAmounts || 0) +
                        //       Number(differenceAmount || 0) -
                        //       Number(amtRecieved || 0)
                        //     ).toFixed(2)
                        // :
                        (differenceAmount < 0
                          ? Math.abs(Number(differenceAmount || 0))
                          : -(Number(differenceAmount || 0))
                        ).toFixed(2)
                      }
                      className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                    />
                  </div>
                ) : (
                  <div className="border border-gray-300 rounded flex justify-center items-center mt-2">
                    <label className="text-sm font-medium">Difference :</label>
                    <input
                      readOnly
                      value={0}
                      className="cursor-not-allowed w-[55%] border-none text-right bg-transparent px-2 py-1 rounded"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Totals & Controls Bar */}
        <div className="flex flex-wrap items-center justify-between gap-4 text-sm my-2 max-w-7xl mx-auto w-full bg-white p-2 rounded-lg">

          {/* Left Section: Filter toggle and Search input */}
          {isTableVisible && !isOnAc && (
            <div className="flex items-center gap-4 flex-1 min-w-[280px]">
              {/* Date Filter Toggle Switch */}
              <div className="flex items-center gap-2 shrink-0">
                <label className="relative inline-block w-[3.5em] h-[2em]">
                  <input
                    type="checkbox"
                    className="peer sr-only"
                    checked={isFilterByDate}
                    onChange={(e) => setIsFilterByDate(e.target.checked)}
                  />
                  <span
                    className="
            absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
            after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
            after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
            after:transition-all after:duration-300 after:ease-in-out
            after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
            peer-checked:bg-blue-500
            peer-checked:after:translate-x-[1.5em]
            peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
            peer-active:after:w-[3em]
            peer-checked:peer-active:after:translate-x-[0.5em]
          "
                  ></span>
                </label>
                <span className="text-sm font-medium whitespace-nowrap">Filter By Date</span>
              </div>

              {/* Search Input */}
              <div className="flex items-center gap-2 border border-gray-300 rounded px-3 py-1.5 flex-1 max-w-md">
                <Search className="h-4 w-4 text-gray-400 shrink-0" />
                <input
                  type="text"
                  placeholder="Search outstanding bills..."
                  value={outstandingSearchTerm}
                  onChange={(e) => setOutstandingSearchTerm(e.target.value)}
                  className="w-full text-sm focus:outline-none bg-transparent"
                />
              </div>
            </div>
          )}

          {/* Middle Section: Inline Date Pickers and Date Actions */}
          {isTableVisible && isFilterByDate && (
            <div className="flex items-center gap-3 bg-gray-50 p-1.5 rounded-md border border-gray-100">
              <div className="flex items-center gap-2">
                <label className="text-xs font-medium text-gray-600 whitespace-nowrap">From:</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="border border-gray-300 px-2 py-1 rounded text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                />
              </div>
              <div className="flex items-center gap-2">
                <label className="text-xs font-medium text-gray-600 whitespace-nowrap">To:</label>
                <input
                  type="date"
                  value={toDate}
                  min={fromDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="border border-gray-300 px-2 py-1 rounded text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                />
              </div>
              <div className="flex items-center gap-1.5 ml-1">
                <button
                  type="button"
                  onClick={fetchOutstandingRV}
                  className="px-3 py-1 text-xs rounded bg-blue-600 text-white shadow hover:bg-blue-700 transition"
                >
                  Apply
                </button>
                <button
                  type="button"
                  onClick={handleClear}
                  className="px-3 py-1 text-xs rounded bg-gray-500 text-white hover:bg-gray-700 transition"
                >
                  Clear
                </button>
              </div>
            </div>
          )}

          {/* Right Section: Core Utility Actions (Save Receipt & Extend Sidebar) */}
          <div className="flex items-center gap-3 ml-auto shrink-0">
            {isTableVisible && (
              <button
                onClick={onSaveReceipt}
                disabled={
                  (!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1) || isChequeInvalid
                }
                className={`relative font-medium text-sm px-4 py-1.5 pl-5 h-[2.5em] rounded-[0.7em] flex items-center overflow-hidden cursor-pointer group transition disabled:opacity-100 disabled:cursor-not-allowed
          ${(!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1) || isChequeInvalid
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
              >
                <span className="mr-8 whitespace-nowrap">
                  {isEditMode ? "Save Edit" : "Save"}
                </span>
                <div
                  className="absolute right-[0.2em] bg-white h-[2.1em] w-[2.1em] rounded-[0.5em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.4em)] active:scale-95"
                >
                  <FaSave
                    className={`${(!isOnAc && transferAccountBlock && inputDifferenceValue?.length < 1)
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-blue-500"
                      }`}
                  />
                </div>
              </button>
            )}

            {isTableVisible && !isOnAc && (
              <button
                className="p-1.5 bg-white text-black rounded border border-gray-300 hover:bg-gray-50 transition flex items-center justify-center"
                onClick={() => setIsExtendTable(!isExtendTable)}
              >
                {isExtendTable ? (
                  <TbLayoutSidebarRightExpand className="text-xl" />
                ) : (
                  <TbLayoutSidebarLeftExpand className="text-xl" />
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {transferAccountBlock && !isOnAc && (
        <div className="flex justify-center ">
          <div className="border border-blue-400 bg-blue-100 rounded-md p-3 my-8 w-[50%]">
            <h3 className="text-md font-semibold text-gray-700 mb-2">
              Difference in Entries
            </h3>

            <div className="grid grid-cols-12 gap-2 items-center text-sm">
              {/* Account Row */}
              <div className="col-span-2 font-medium">Account</div>
              <div className="col-span-10  px-2 py-1 rounded">
                {/* {account} */}

                {/* {inputDebitValue} */}

                <input
                  type="text"
                  value={
                    inputDifferenceValue === "-" ? "" : inputDifferenceValue
                  }
                  onChange={(e) => {
                    setDifferenceDropdownOpen(true);
                    setinputDifferenceValue(e.target.value);
                    setselectedDifferenceAccount(null);
                  }}
                  placeholder="Enter Difference Account"
                  className="w-full px-2 pr-8 py-1 rounded outline-none border border-gray-300 focus:ring-0 text-gray-900"
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      // e.preventDefault();
                      fetchAccountList("EXPENSES");
                      setDifferenceModalOpen(true);
                      setDifferenceDropdownOpen(false);
                    }
                  }}
                />
                {(selectedDifferenceAccount ||
                  (inputDifferenceValue && inputDifferenceValue !== "-")) && (
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      onClick={clearDifferenceAccounts}
                    >
                      <ClearIcon fontSize="small" />
                    </button>
                  )}
              </div>
              {/* Dropdown */}
              {differenceDropdownOpen && filteredCreditAccounts?.length > 0 && (
                <ul
                  className="absolute left-0 right-0 bg-white border border-gray-300 mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {filteredCreditAccounts?.map((acc, i) => (
                    <li
                      key={i}
                      onClick={() => {
                        setDifferenceDropdownOpen(false);
                        setinputDifferenceValue(
                          `${acc.ACCOUNT} | ${acc.DESCRIPTION}`,
                        );
                        setinputDifferenceValueAccount(acc.ACCOUNT);
                        setinputDifferenceValueDescription(acc.DESCRIPTION);
                        setselectedDifferenceAccount(acc);
                      }}
                      className="px-3 py-2 text-sm flex items-center gap-4 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                    >
                      <div className="text-sm text-white px-2 py-0.5 rounded-xl bg-blue-500">
                        {acc.ACCOUNT}
                      </div>
                      <div className="font-medium text-gray-900 text-sm line-clamp-2">
                        {acc.DESCRIPTION}
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {/* REF + Amount Row */}
              <div className="col-span-2 font-medium">REF</div>
              <div className="col-span-4 bg-white px-2 py-1 rounded">
                {/* {refValue} */}ON A/C
              </div>
              <div className="col-span-2 font-medium text-right">Amount</div>
              <div className="col-span-4 bg-white px-2 py-1 rounded">
                <input
                  className="w-40 focus:outline-none border-none"
                  value={differenceAmount || 0}
                  onChange={(e) => setDifferenceAmount(e.target.value)}
                />

                {/* {amtRecieved - sumOfAmounts} */}
                {/* Debit - Credit in Receipt */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Outstanding Table */}



      {isTableVisible && !isOnAc && (
        <div className="max-h-[800px] max-w-7xl mx-auto overflow-y-auto border rounded mb-20 bg-white">
          <table className="relative w-full text-sm border-collapse">
            <thead className="">
              <tr>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1    font-semibold">
                  Amount
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1 z-10  font-semibold">
                  Select
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                  Bal Amount
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                  Inv No
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                  Inv Date
                </th>
                <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                  Description
                </th>
                {isExtendTable && (
                  <>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Job Code
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Cost Center
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Cur
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Rate
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      FC Amount
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      INV Amt
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      RET Amt
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      RET Dt
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Salesman
                    </th>
                    <th className="bg-gray-100 sticky top-0 border px-2 py-1   font-semibold">
                      Dept No
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const filtered = (outstandingRV || []).reduce((acc, item, idx) => {
                  if (!outstandingSearchTerm) { acc.push({ item, idx }); return acc; }
                  const term = outstandingSearchTerm.toLowerCase();
                  if (
                    String(item.INV || "").toLowerCase().includes(term) ||
                    String(item.DESCR || "").toLowerCase().includes(term) ||
                    String(item.BALAMT || "").toLowerCase().includes(term) ||
                    String(item.JOBCODE || "").toLowerCase().includes(term) ||
                    String(item.CUR || "").toLowerCase().includes(term)
                  ) {
                    acc.push({ item, idx });
                  }
                  return acc;
                }, []);
                return filtered.length > 0 ? filtered.map(({ item: outRV, idx: index }) => (
                  <tr key={index}>
                    <td className="border w-24 bg-white ">
                      <input
                        type="number"
                        value={amounts[index] ?? ""}
                        onChange={(e) =>
                          handleAmountChange(index, e.target.value)
                        }
                        className="w-full border-none  text-right rounded"
                      />
                    </td>
                    {/* <td className="border bg-white px-2 py-1 text-right">{outRV?.SELECT}</td> */}
                    <td className="border w-24  bg-white px-2 py-1 text-center">
                      <label className="relative inline-block w-[3.5em] h-[2em]">
                        <input
                          type="checkbox"
                          className="peer sr-only"
                          checked={!!selectedToggle[index]}
                          onChange={(e) =>
                            handleSelectToggle(
                              index,
                              e.target.checked,
                              outRV?.BALAMT,
                            )
                          }
                        />
                        <span
                          className="
      absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
      after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
      after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
      after:transition-all after:duration-300 after:ease-in-out
      after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
      peer-checked:bg-blue-500
      peer-checked:after:translate-x-[1.5em]
      peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
      peer-active:after:w-[3em]
      peer-checked:peer-active:after:translate-x-[0.5em]
    "
                        ></span>
                      </label>
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {outRV?.BALAMT}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {outRV?.INV}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {dayjs(outRV?.INVDATE).format("DD/MM/YYYY")}
                    </td>
                    <td className="border bg-white px-2 py-1 text-left">
                      {outRV?.DESCR}
                    </td>
                    {isExtendTable && (
                      <>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outRV?.JOBCODE}
                        </td>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outRV?.COSTC}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.CUR}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.RATE}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.FCBalAmt}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.INVAMOUNT}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.RETAMT}
                        </td>
                        <td className="border bg-white px-2 py-1 text-right">
                          {outRV?.ReturnDt}
                        </td>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outRV?.SALESMAN}
                        </td>
                        <td className="border bg-white px-2 py-1 text-center">
                          {outRV?.DEPTNO}
                        </td>
                      </>
                    )}
                  </tr>
                ))
                  : (
                    <tr>
                      <td
                        colSpan={isExtendTable ? 11 : 6}
                        className="text-center py-4 text-gray-500"
                      >
                        No outstanding data available
                      </td>
                    </tr>
                  );
              })()}
            </tbody>
          </table>
        </div>
      )}

      {creditModalOpen && (
        <Modal
          isOpen={creditModalOpen}
          onClose={() => setCreditModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleCrAccountSelect}
          />
        </Modal>
      )}

      {debitModalOpen && (
        <Modal
          isOpen={debitModalOpen}
          onClose={() => setDebitModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="Bank"
            handleCustomerSelect={handleDrAccountSelect}
          />
        </Modal>
      )}

      {transferAccountPopup && !isOnAc && (
        <div className="fixed inset-0 flex items-center justify-center z-30 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="px-4 py-3 bg-yellow-50 border-b border-yellow-200">
              <h2 className="text-yellow-700 font-semibold text-base flex items-center gap-2">
                ⚠️ Warning
              </h2>
            </div>

            {/* Body */}
            <div className="px-5 py-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                Voucher not tallied. Do you want to continue with adjustment?
              </p>
            </div>

            {/* Footer */}
            <div className="px-5 py-3 flex justify-end gap-3 border-t bg-gray-50">
              <button
                onClick={onCloseTransferPopup}
                className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm rounded-md transition"
              >
                No
              </button>
              <button
                onClick={onConfirmPaymentTransferPopup}
                className="px-4 py-1.5 bg-red-500 hover:bg-red-600 text-white text-sm rounded-md shadow-sm transition"
              >
                Yes, Continue
              </button>
            </div>
          </div>
        </div>
      )}
      {differenceModalOpen && (
        <Modal
          isOpen={differenceModalOpen}
          onClose={() => setDifferenceModalOpen(false)}
          title={"Customer List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleonAccountSelect}
          />
        </Modal>
      )}
      {receiptSavedPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-30 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="px-4 py-3 bg-green-200 border-b border-green-200">
              <h2 className="text-green-700 font-semibold text-base flex items-center gap-2">
                {isEditMode ? "Edit Receipt" : " Save Receipt"}
              </h2>
            </div>

            {/* Body */}
            <div className="px-5 py-4">
              <p className="text-gray-700 text-sm leading-relaxed">
                Receipt Voucher #{vNO} {isEditMode ? "Editted" : "Saved"}{" "}
                Succesfully!
              </p>
            </div>

            {/* Footer */}
            <div className="px-5 py-3 flex justify-end gap-3 border-t bg-gray-50">
              <button
                onClick={onCloseSaveRVPopup}
                className="px-4 py-1.5 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm rounded-md transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reciept;
